module.exports = __webpack_public_path__ + "img/img0.b2ab8b1d.jpg";